import { render, staticRenderFns } from "./SingleImageChoice.vue?vue&type=template&id=3c9d7c68&scoped=true"
import script from "./SingleImageChoice.vue?vue&type=script&lang=js"
export * from "./SingleImageChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9d7c68",
  null
  
)

export default component.exports